export { GenEdPage as default } from '@admin-web/module/genEd'
